import { ScriptLoaderService } from '../../script-loader.service';
import { StyleLoaderService } from '../../style-loader.service';

window.addEventListener('DOMContentLoaded', async () => {
  const scriptLoader = new ScriptLoaderService();
  const styleLoader = new StyleLoaderService();

  const $mapElements = document.querySelectorAll<HTMLElement>('.cmp-maze-map');

  if ($mapElements.length > 0) {
    await scriptLoader.loadScript(
      'https://api.mazemap.com/js/v2.0.106/mazemap.min.js'
    );
    await styleLoader.loadStyle(
      'https://api.mazemap.com/js/v2.0.106/mazemap.min.css'
    );
  }

  Array.from($mapElements).forEach(($element) => {
    const $mapElement =
      $element.querySelector<HTMLElement>('.cmp-maze-map__map');

    if ($mapElement) {
      const zoom = $element.dataset['zoom'];
      const level = $element.dataset['level'];
      const centre = $element.dataset['centre'];
      const campuses = $element.dataset['campuses'];
      if (centre && zoom) {
        const map = new (window as any).Mazemap.Map({
          container: $mapElement,
          campuses: campuses,
          center: {
            lat: parseFloat(centre.split(',')[1]),
            lng: parseFloat(centre.split(',')[0]),
          },
          zoom: zoom,
          zLevel: level,
        });

        map.addControl(
          new (window as any).Mazemap.mapboxgl.NavigationControl()
        );
        map.scrollZoom.disable();
      }
    }
  });
});
